import type { SendbirdChatSDK } from '@sendbird/uikit-utils';
import { createContext, useContext } from 'react';

const initialContext = {
    sdk: null as SendbirdChatSDK | null,
    isLoading: true,
};

export const SendbirdContext =
    createContext<typeof initialContext>(initialContext);

const useSendbird = () => {
    const context = useContext(SendbirdContext);

    if (context == null) {
        throw new Error('useSendbird must be used within SendbirdProvider');
    }

    return context;
};

export default useSendbird;
